module.exports = __webpack_public_path__ + "static/media/red.184794a0.webp";